import React from 'react';
import PropTypes from 'prop-types';
import { Card, CardBody, CardHeader, Col, Row, FormGroup, Form } from 'reactstrap';
import InputGroup from '../../../components/cms/form/inputGroup';
import SubmitButtons from '../../../components/cms/form/submitButtons';
import InputFile from '../../../components/cms/form/inputFile';
import PreviewImage from '../../../components/previewImage';

const twoCols = { xs: 12, md: 6 };

const Item = ({
  t,
  onChange,
  onSubmit,
  errors,
  formData,
  title,
  isSubmitting,
  isSubmittingRedirect,
  imageSrc,
}) => (
  <div>
    <Row>
      <Col md={12}>
        <Card>
          <CardHeader>
            <strong><i className="fa fa-rocket pr-2" />{title}</strong>
          </CardHeader>
          <CardBody>
            <Form onSubmit={onSubmit(true)}>
              <FormGroup row className="my-0">
                <Col {...twoCols}>
                  <InputGroup
                    name="name"
                    label={t('Name')}
                    onChange={onChange}
                    errors={errors}
                    value={formData.name}
                    icon="fa fa-flag"
                  />
                </Col>
                <Col {...twoCols}>
                  <InputGroup
                    name="title"
                    label={t('Title')}
                    onChange={onChange}
                    errors={errors}
                    value={formData.title}
                    icon="fa fa-flag-o"
                  />
                </Col>
              </FormGroup>
              <InputGroup
                name="git"
                label={t('Git')}
                onChange={onChange}
                errors={errors}
                value={formData.git}
                icon="fa fa-flag-o"
              />
              <Row>
                <Col md={12}>
                  <SubmitButtons
                    isSubmitting={isSubmitting}
                    onSubmit={onSubmit}
                    isSubmittingRedirect={isSubmittingRedirect}
                  />
                </Col>
              </Row>
            </Form>
          </CardBody>
        </Card>
      </Col>
    </Row>
  </div>
);

Item.propTypes = {
  t: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  isSubmittingRedirect: PropTypes.bool.isRequired,
  onSubmit: PropTypes.func.isRequired,
  errors: PropTypes.object.isRequired,
  formData: PropTypes.object.isRequired,
  title: PropTypes.string.isRequired,
  isSubmitting: PropTypes.bool.isRequired,
  imageSrc: PropTypes.string.isRequired,
};

export default Item;



// WEBPACK FOOTER //
// ./src/views/extModules/item/Item.jsx